import approvalSummary from "./approval-summary";
import approvalQueue from "./approval-queue";
import { combineReducers } from "redux";

export default combineReducers({
  approvalSummary,
  approvalQueue,
});
